
import React from 'react';
import { Button, Typography, Box } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

export default function CompletionPage({ handleRestart }) {
  return (
    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" style={{ textAlign: 'center' }}>
      <CheckCircleIcon style={{ fontSize: 100, color: '#4caf50' }} />
      <Typography variant="h4" gutterBottom>
        설정이 완료되었습니다!
      </Typography>
      <Button variant="contained" color="primary" onClick={handleRestart} style={{ marginTop: '16px' }}>
        처음으로
      </Button>
    </Box>
  );
}
